<script setup>
import { computed } from '#imports';
import { authorSlugs } from '~/constants/author-slugs';

const props = defineProps({
  crew: {
    type: Array,
    required: true,
  },
  isAuthors: {
    type: Boolean,
    default: false,
  },
  isLight: {
    type: Boolean,
    default: false,
  },
  generalAuthorId: {
    type: String,
    default: undefined,
  },
});

const items = computed(() =>
  props.crew.filter(({ speciality, staff }) =>
    props.isAuthors
      ? authorSlugs.includes(speciality.slug.current) &&
        staff._id !== props.generalAuthorId
      : !authorSlugs.includes(speciality.slug.current)
  )
);
</script>

<template>
  <ul class="article-crew">
    <li v-for="item in items" :key="item._id" class="article-crew__item">
      <NuxtLink
        :to="{
          name: 'members-slug',
          params: { slug: item.staff.slug.current },
        }"
      >
        <ArticleCrewMember
          :crew-member="item"
          :with-avatar="isAuthors"
          :is-light="isLight"
        />
      </NuxtLink>
    </li>
    <li v-if="$slots.lastElement" class="article-crew__item">
      <slot name="lastElement" />
    </li>
  </ul>
</template>

<style lang="postcss" scoped>
.article-crew {
  display: inline-flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;

  &__item {
    max-width: 260px;
  }

  @media (--small-vp) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 12px;

    &__item {
      max-width: none;
      overflow: hidden;
    }
  }
}
</style>
